import axios from 'axios'

const config = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
}

const defaultNote = () => {
    return {
        title: null,
        body: null,
        priority: null,
        state: 0,
        assignee: null,
        author: localStorage.getItem('username'),
        deadline: null
    }
}

const defaultFilters = () => {
    return {
        active: true,
        archived: false,
        priority: null,
        assignee: null,
        author: null
    }
}

function filterNotes(list, filters) {
    let res = list

    if (!filters.active) {
        res = res.filter(el => el.state != 0)
    }

    if (!filters.archived) {
        res = res.filter(el => el.state != 1)
    }

    if (filters.priority) {
        res = res.filter(el => el.priority == filters.priority)
    }

    if (filters.assignee) {
        res = res.filter(el => el.assignee == filters.assignee)
    }

    if (filters.author) {
        res = res.filter(el => el.author == filters.author)
    }

    return res
}

const note = {
    state: {
        list: [],
        filteredList: [],
        new: defaultNote(),
        filters: defaultFilters()

    },
    mutations: {
        SET_NOTE_LIST(state, payload) {
            state.list = payload
            state.filteredList = filterNotes(state.list, state.filters)
        },

        SET_NEW_NOTE_TITLE(state, payload) {
            state.new.title = payload
        },
        SET_NEW_NOTE_BODY(state, payload) {
            state.new.body = payload
        },
        SET_NEW_NOTE_PRIORITY(state, payload) {
            state.new.priority = payload
        },
        SET_NEW_NOTE_ASSIGNEE(state, payload) {
            state.new.assignee = payload
        },
        SET_NEW_NOTE_DEADLINE(state, payload) {
            state.new.deadline = payload
        },

        SET_NOTE_FILTER_ACTIVE(state, payload) {
            state.filters.active = payload

            state.filteredList = filterNotes(state.list, state.filters)
        },
        SET_NOTE_FILTER_ARCHIVED(state, payload) {
            state.filters.archived = payload

            state.filteredList = filterNotes(state.list, state.filters)
        },
        SET_NOTE_FILTER_PRIORITY(state, payload) {
            state.filters.priority = payload

            state.filteredList = filterNotes(state.list, state.filters)
        },
        SET_NOTE_FILTER_ASSIGNEE(state, payload) {
            state.filters.assignee = payload

            state.filteredList = filterNotes(state.list, state.filters)
        },
        SET_NOTE_FILTER_AUTHOR(state, payload) {
            state.filters.author = payload

            state.filteredList = filterNotes(state.list, state.filters)
        },

        RESET_NEW_NOTE(state) {
            state.new = defaultNote()
        },
        RESET_NOTE_FILTERS(state) {
            state.filters = defaultFilters()

            state.filteredList = filterNotes(state.list, state.filters)
        },
    },
    actions: {
        async fetchNotes({
            commit
        }) {

            let {
                data
            } = await axios.get(`${process.env.VUE_APP_API}/notes/fetch`, config)

            data = data.map(el => {
                el.note = `${el.title} ${el.body}`
                return el
            })

            commit('SET_NOTE_LIST', data)
        },

        async createNote({
            state,
            commit
        }) {
            let {
                data
            } = await axios.post(`${process.env.VUE_APP_API}/notes/create`, state.new, config)

            if (data.status) {
                commit('RESET_NEW_NOTE')
            }

            return data.status
        },

        async editNote({
            state,
            commit
        }, payload) {
            let {
                data
            } = await axios.post(`${process.env.VUE_APP_API}/notes/edit`, payload, config)

            return data.status
        },

        async deleteNote(context, payload) {
            let {
                data
            } = await axios.post(`${process.env.VUE_APP_API}/notes/delete`, payload, config)

            return data.status
        },

        async archiveNote(context, payload) {
            let {
                data
            } = await axios.post(`${process.env.VUE_APP_API}/notes/archive`, payload, config)

            return data.status
        }
    },
    getters: {
        getNoteFiltes: state => state.filters,
        getNewNote: state => state.new,
        getNotes: state => state.filteredList,
    }
}

export default note